module.exports = __webpack_public_path__ + "img/6-3.f4b39c1a.png";